import {
  type EconomyReport,
  EconomyReportSchema,
  type ReportsResponse,
  ReportsResponseSchema,
  type SanctionsResponse,
  SanctionsResponseSchema,
} from '@shefira/shared';
import { z } from 'zod';

import { call } from './account.js';

/**
 * The moderation endpoints (ADR 0037, ADR 0038), read by the game master's
 * window with the character session token. The server checks the account's
 * admin flag on every call; these only read the database and close a report.
 */

export async function fetchReports(
  token: string,
  status: 'open' | 'closed',
): Promise<ReportsResponse> {
  return call(`/moderation/reports?status=${status}`, ReportsResponseSchema, {
    method: 'GET',
    token,
  });
}

export async function closeReport(token: string, id: string): Promise<void> {
  await call(`/moderation/reports/${encodeURIComponent(id)}/close`, z.unknown(), {
    method: 'POST',
    token,
  });
}

export async function fetchSanctions(token: string, name: string): Promise<SanctionsResponse> {
  return call(`/moderation/sanctions?name=${encodeURIComponent(name)}`, SanctionsResponseSchema, {
    method: 'GET',
    token,
  });
}

export async function fetchEconomy(token: string): Promise<EconomyReport> {
  return call('/moderation/economy', EconomyReportSchema, { method: 'GET', token });
}
